import React from 'react';

import { AuthProvider } from './auth';
import { ToastProvider } from './toast';
import { ProductInfoProvider } from './productInformation';

const AppProvider: React.FC = ({ children }) => (
  <ToastProvider>
    <AuthProvider>
      <ProductInfoProvider>{children}</ProductInfoProvider>
    </AuthProvider>
  </ToastProvider>
);

export default AppProvider;
